import React from 'react'

export const Node = ({ attributes, children }) =>
  <table style={{ width: '100%' }}>
    <tbody {...attributes}>
      {children}
    </tbody>
  </table>

export const RowNode = ({ attributes, children }) =>
  <tr {...attributes}>
    {children}
  </tr>

export const CellNode = ({ attributes, node, children }) =>
  <td
    style={{ backgroundColor: node.data.get('backgroundColor') }}
    {...attributes}>
    {children}
  </td>



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Table/Node.js